import { Header } from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import HowItWorks from "@/components/landing/HowItWorks";
import Features from "@/components/landing/Features";
import Control from "@/components/landing/Control";
import Comparison from "@/components/landing/Comparison";
import Pricing from "@/components/landing/Pricing";
import LeadForm from "@/components/landing/LeadForm";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#09090b] text-white lp-grain">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <Features />
        <Control />
        <Comparison />
        <Pricing />
        <LeadForm />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
